import { Adapter } from './adapters/types';
import { sentryAdapter } from './adapters/sentry';
import { visitSignalsAdapter } from './adapters/visitSignals';

export const ANALYTICS_ENABLED = true;

export const ANALYTICS_ADAPTERS: Adapter[] = [sentryAdapter, visitSignalsAdapter];
